// Module
var code = "<div ng-keypress=\"ctrl.preventNewLines($event)\" ng-mouseover=\"ctrl.enableEdition()\" ng-mouseleave=\"ctrl.disableEdition()\" contenteditable=\"true\"> {{ctrl.sEditableText}} <span ng-show=\"ctrl.editable\" ng-include=\"ctrl.editIcon\"></span> </div> ";
// Exports
module.exports = code;